import {
  CurrentStudentConflictsData,
  SignalsPayload,
} from "@timeedit/registration-schemas";
import { useMemo } from "react";
import { ConflictNotification } from "../Conflict";
import "./signalSummary.scss";
import { Badge } from "../Badge";

type SignalSummaryProps = {
  signal: SignalsPayload;
  translations: {
    registered: string;
    notRegistered: string;
  };
  conflicts?: CurrentStudentConflictsData;
};
export function SignalSummary({
  signal,
  translations,
  conflicts,
}: SignalSummaryProps): React.JSX.Element {
  const hasConflicts = useMemo(
    () =>
      conflicts
        ? Object.values(conflicts).some((conflict) => conflict.allocated)
        : false,
    [conflicts]
  );

  return (
    <>
      <div className="success__wrapper">
        <Badge
          status="success"
          text={`${translations.registered} ${signal.summary.OK}`}
          className="success__badge"
        />
        {hasConflicts && <ConflictNotification />}
      </div>

      <Badge
        status="error"
        text={`${translations.notRegistered} ${signal.summary.ISSUE}`}
      />
    </>
  );
}
